import React from "react";
import {Field, FieldProps, Formik, FormikProps} from "formik";
import {useTranslation} from "react-i18next";
import {Company} from "../../../../../types/company";
import {useDispatch, useSelector} from "react-redux";
import {State} from "../../../../../redux/store";
import {useSnack} from "../../../../../utils/useSnack";
import {Autocomplete, Grid, TextField, Typography} from "@mui/material";
import digitsOnly from "../../../../../utils/digitsOnly";
import {NewCommonForm, initialValues, ValidationSchema} from "./formik";
import {useDictionary} from "../../../../../utils/useDictionary";
import {AuctionType} from "../../../../../utils/enums";

export const CommonFields = ({
                                 formikRef, editingInitialState, company, disable = false,
                             }: {
    formikRef: React.RefObject<FormikProps<NewCommonForm>>;
    editingInitialState?: NewCommonForm,
    company: Company,
    disable?: boolean,
}) => {
    const onSubmit = (values: NewCommonForm) => {
    };
    const {t} = useTranslation();

    const state = useSelector((state: State) => state);

    const dispatch = useDispatch();
    const {snack} = useSnack();

    const auctionType = useDictionary(
        AuctionType,
        (type) => ({value: type, label: t(`auction_type.${type}`)}),
        editingInitialState?.auctionType || {value: AuctionType.tender, label: t("auction_type.tender")}
    );

    React.useEffect(() => {
        formikRef.current?.setFieldValue(
            "auctionType", auctionType.selected, false);
    }, [auctionType.selected]);

    formikRef.current?.setFieldValue("companyId", company!.id)
    return (
        <Formik innerRef={formikRef}
                initialValues={editingInitialState || initialValues}
                validationSchema={ValidationSchema()}
                onSubmit={onSubmit}
                validateOnMount
        >
            {(frops: FormikProps<NewCommonForm>) => (
                <Grid container>
                    <Grid container columnSpacing={3} rowSpacing={1}>
                        <Grid item xs={12} sx={{mb: 1}}>
                            <Typography variant="h6">
                                {t("cabinet.new_plan_item.sections.customer")}
                            </Typography>
                        </Grid>
                        <Field
                            type="hidden"
                            name="companyId"
                        />

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth color="primary" type="text" size="small"
                                value={company?.title ?? ""} name="title"
                                label={t("auction.fields.companyTitle")}
                                InputProps={{readOnly: true}}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth color="primary" type="text" size="small"
                                value={digitsOnly(company?.itn) ?? ""} name="itn"
                                label={t("auction.fields.companyItn")}
                                InputProps={{readOnly: true}}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>

                            <Autocomplete
                                disablePortal
                                disabled={disable}
                                options={auctionType.dictionary}
                                value={auctionType.selected}
                                onChange={auctionType.onSelectChange}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                fullWidth
                                size={"small"}
                                renderInput={params =>
                                    <Field name={"auctionType"}>
                                        {({field, form, meta}: FieldProps) => (
                                            <TextField {...params} fullWidth color="primary"
                                                       label={t("cabinet.plan.filter.auctionType")}
                                                       error={!!(meta.touched && meta.error)}
                                                       helperText={meta.touched && meta.error}
                                            />
                                        )}
                                    </Field>
                                }
                            />
                        </Grid>

                        <Field type="hidden" name="companyId" value={company!.id}/>

                    </Grid>
                </Grid>
            )}
        </Formik>
    )
}